import Seo from "@/components/site/Seo";
import Section from "@/components/site/Section";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import Marquee from "@/components/site/Marquee";
import Hero from "@/components/sections/Hero";
import Pillars from "@/components/sections/Pillars";
import ProblemSection from "@/components/sections/ProblemSection";
import AmenityShowcase from "@/components/sections/AmenityShowcase";
import Timeline from "@/components/sections/Timeline";
import Comparison from "@/components/sections/Comparison";
import Personas from "@/components/sections/Personas";
import AboutSection from "@/components/sections/AboutSection";
import PartnersSection from "@/components/sections/PartnersSection";
import Faq from "@/components/sections/Faq";
import StayInLoop from "@/components/sections/StayInLoop";
import FinalCta from "@/components/sections/FinalCta";

export default function Home() {
  return (
    <>
      <Seo
        title="RestPower | More Than a Charge. It's a Better Stop."
        description="RestPower is reimagining the EV charging experience with comfortable lounges, clean restrooms, Wi-Fi, food and convenient amenities while your vehicle charges."
        path="/"
      />
      <Hero />
      <Pillars />
      <Marquee items={["Charge", "Eat", "Rest", "Work", "Play", "Shop", "Refresh"]} />
      <ProblemSection />

      <Section id="experience" bg="surface">
        <Reveal className="max-w-3xl">
          <SectionHeading overline="The RestPower Experience" title={<>A destination,<br />not a detour.</>} />
          <p className="mt-6 text-base leading-relaxed text-white/55 md:text-lg">
            RestPower is designed around a simple idea: the time your vehicle spends charging should become
            useful time for you. Step through every corner of the concept.
          </p>
        </Reveal>
        <div className="mt-16 md:mt-20">
          <AmenityShowcase />
        </div>
      </Section>

      <Timeline />
      <Comparison />
      <Personas />
      <AboutSection />
      <PartnersSection />
      <Faq />
      <StayInLoop />
      <FinalCta />
    </>
  );
}
